var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-12",attrs:{"fluid":""}},[_c('v-row',{staticClass:"mb-12",staticStyle:{"gap":"20px"},attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('div',{staticClass:"no-results"},[_vm._v("No results found")])]),(_vm.ring === true)?_c('v-row',{staticClass:"ring"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }